/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const newCustomer = /* GraphQL */ `
  mutation NewCustomer($customer: NewCustomer!) {
    newCustomer(customer: $customer) {
      id
      name
      status
      comments
      createdAt
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer($customer: CustomerInput!) {
    updateCustomer(customer: $customer) {
      id
      name
      status
      comments
      createdAt
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer($id: ID!) {
    deleteCustomer(id: $id) {
      id
      name
      status
      comments
      createdAt
    }
  }
`;
